<template>
    <div>
        <div v-if="showGraph" class="popup w-75">
            <div class="d-flex align-items-center mb-2">
                <div class="me-2">
                    <h3>{{ $t('dataheaders.hum_graph') + ' ' + deviceName }}</h3>
                </div>
                <div class="ms-auto">
                    <button @click="closePopup" class="btn-close" aria-label="Close"></button>
                </div>
            </div>
            <div class="d-flex align-items-center mb-2" v-if="humidityData.length > 0">
                <select v-model="selectedSpan" class="form-select me-2">
                    <option value="1 day">24 h</option>
                    <option value="1 week">1 {{ $t('week') }}</option>
                    <option value="1 month">1 {{ $t('month') }}</option>
                    <option v-if="isAdmin" value="1 year">1 {{ $t('year') }}</option>
                </select>
            </div>
            <div id="humidity-chart"></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Highcharts from 'highcharts';
const { getCookie } = require('@/helpers');

export default {
    props: {
        showGraph: {
            type: Boolean,
            default: false
        },
        deviceName: {
            type: String,
            default: ''
        },
        isAdmin: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedSpan: '1 day',
            span: '1 day',
            humidityData: []
        };
    },
    watch: {
        showGraph(newVal) {
            if (newVal) {
                this.fetchHumidityData(this.span);
            }
        },
        selectedSpan(newVal) {
            this.span = newVal;
            this.fetchHumidityData(newVal);
        }
    },
    methods: {
        closePopup() {
            this.$emit('close-popup');
        },
        async fetchHumidityData(span) {
            this.humidityData = [];
            axios.get(`${this.$url}/humidity`, {
                params: {
                    device: this.deviceName,
                    span: span
                },
                headers: {
                    Authorization: 'Bearer ' + getCookie('token'),
                    ContentType: 'application/json'
                }
            })
                .then(response => {
                    //console.log('Humidity data:', response.data);
                    if (response.data.length > 0) {
                        this.humidityData = response.data;
                        this.renderHumidityChart(this.humidityData);
                    } else {
                        this.humidityData = [];
                        this.renderHumidityChart(this.humidityData);
                    }
                })
                .catch(error => {
                    console.error('Failed to fetch temperature data:', error);
                });
        },
        renderHumidityChart(humidityData) {

            // Transform the data
            const transformedData = humidityData.map(entry => {
                return [new Date(entry.timestamp).getTime(), entry.humidity];
            });
            // Set timezone to Helsinki
            Highcharts.setOptions({
                time: {
                    timezone: 'Europe/Helsinki'
                }
            });
            // Render the chart with transformed data
            Highcharts.chart('humidity-chart', {
                accessibility: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                xAxis: {
                    type: 'datetime',
                    title: {
                        text: this.$t('dataheaders.time'),
                    }
                },
                yAxis: {
                    title: {
                        text: this.$t('dataheaders.humidity') + ' %'
                    }
                },
                series: [{
                    name: this.$t('dataheaders.humidity'),
                    data: transformedData,
                }],
            });
        },
    },
};
</script>

<style>
.popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
}
</style>